<template>
    <fragment>
        <Title>{{activityName}}</Title>
        <div :key="index" v-for="(item,index) in infoObj.list">
            <BillPage v-if="item.tag=='grid'" :activityId="activityId" :activityStatus="activityStatus" :openId="openId"
                :info="item" @handleGridClick="handleGridClick" :nickName="nickName" :targetId="targetId" />
        </div>

    </fragment>
</template>

<script>
import { isMiniApplets } from "@/utils/browser";
import { getQueryString } from "@/utils/utils";
import { loadScript, encodeSearchParams } from "@/utils/utils";
export default {
    name: "Bill",
    data() {
        return {
            openId: "",
            activityStatus: "",
            infoObj: {},
            showPopup: true,
            activityName: "",
            activityId: "",
            pageNo: "",
            nickName: "",
            targetId: "",
            test: ''
        }
    },

    mounted() {
        this.activityId = getQueryString("activityId");
        this.pageNo = getQueryString("pageNo");
        this.openId = getQueryString("openId");
        this.targetId = getQueryString("targetId");
        let userId = getQueryString("userId")
        this.test = getQueryString("test")
        localStorage.setItem("userId", userId)
        let nickName = decodeURIComponent(getQueryString("nickName"));
        this.nickName = nickName && nickName.length > 8 ? `${nickName.slice(0, 8)}...` : nickName
        this.getPageConfig().then(() => {
            this.$log.senLog({
                pointID: '12020001',
                eventType: 1,
                businessData: {
                    source: isMiniApplets() == 'wechat' ? 'WUC' : 'ZUC'
                }
            })
        }).catch(_ => {
            this.$log.senLog({
                pointID: '12020001',
                eventType: 1,
                businessData: {
                    source: isMiniApplets() == 'wechat' ? 'WUC' : 'ZUC'
                }

            })
        })

    },

    methods: {
        // 获取配置项
        getPageConfig() {
            return new Promise((resolve, reject) => {
                let params = {
                    activityId: this.activityId,
                    openId: this.openId,
                    pageNo: this.pageNo,
                    test: this.test
                };
                this.$ebLoading.show();
                this.$fetch(
                    { url: "/ehs/activity/page/config", method: "post" },
                    params
                ).then(res => {
                    this.$ebLoading.hide();
                    if (res.success) {
                        this.infoObj = {};
                        setTimeout(() => {
                            this.infoObj = JSON.parse(res.model.pageContent);
                            this.activityStatus = res.model.activityStatus;
                            this.activityName = res.model.activityName;
                        }, 300);
                        resolve(res.model.talkingDataAppId);
                    } else {
                        if (res.errorCode == "CLA100077") {
                            console.log("没有页面");
                            return;
                        }
                        this.$toast({
                            styles: {
                                maskColor: "rgba(0,0,0,0)",
                                background: "rgba(0,0,0,0.4)",
                                messageColor: "#fff"
                            },
                            content: res.errorMessage,
                            duration: 2000
                        }).then(() => {
                            console.log("finish");
                        });
                    }
                }).finally(() => {
                    this.$ebLoading.hide();
                })
            });
        },
        close(val) {
            this.showPopup = val;
        },
        // 热区点击操作统一跳转
        hotAreaHandleClick(val) {
            if (val.jumpType == 2) {
                this.pageNo = val.pagePath;
                this.getPageConfig();
            } else if ([3, 4].includes(val.jumpType)) {
                this.urlFor(val);
            } else if (val.jumpType == 1) {
                // alert("无");
            }
        },
        // 九宫格点击
        handleGridClick(val) {
            console.log(val)
            this.hotAreaHandleClick(val)
        },
        // 固钉点击操作
        handleAffixClick(val) {
            this.hotAreaHandleClick(val);
        },
        // 音频热区点击操作
        handleAudioClick(val) {
            this.hotAreaHandleClick(val);
        },
        // 图片区域点击操作
        handleImgClick(val) {
            this.hotAreaHandleClick(val);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>